<template>
  <van-popup position="bottom" v-model="isShow">
    <div class="container f28">
      <div class="title">物流信息</div>
      <ul>
        <li><span>快递公司：顺丰快递</span></li>
        <li>
          <span>快递单号：12345678</span>
          <button class="copy-btn" v-copy="'测试copy'">复制</button>
        </li>
      </ul>
      <div class="close" @click="hide"></div>
    </div>
  </van-popup>
</template>

<script>
  import { Popup } from 'vant'
  export default {
    name: 'selectService',
    components: {
      'van-popup': Popup
    },
    data () {
      return {
        isShow: false
      }
    },
    methods: {
      show () {
        this.isShow = true
      },
      hide () {
        this.isShow = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .van-popup--bottom{
    width: 101%;
  }
  .container{
    min-height: 380px;
    padding: 30px;
    position: relative;
    .title{
      line-height: 40px;
      margin-bottom: 50px;
    }
    li{
      line-height: 40px;
      margin-bottom: 30px;
      .copy-btn{
        margin-left: 20px;
      }
    }
    .bottom{
      position: absolute;
      width: 690px;
      bottom: 30px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      .submit{
        margin-left: 20px;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
  }
</style>
